import { Button } from '@svenskaspelab/ui/react/button';
import Dustbin from '@svenskaspelab/ui/react/icons/Dustbin';
import type { ReactNode } from 'react';

import type { CouponIndex } from '../../schema/coupon/entry.js';

type ClearCouponButtonProps = {
  couponIndex: CouponIndex;
};

/**
 * Element containing a button to clear a coupon.
 *
 * @param root0 Object containing the function to clear coupon
 * @param root0.couponIndex Index of the coupon to be cleared
 * @returns JSX.Element
 */
export default function ClearCouponButton({ couponIndex }: ClearCouponButtonProps): ReactNode {
  return (
    <Button
      className="z-2"
      variant="outline"
      name="clear"
      type="submit"
      form="coupon_form"
      value={couponIndex}
      aria-label={`Rensa rad ${couponIndex + 1}`}
    >
      <Dustbin />
    </Button>
  );
}
